export type Zone = {
  name: string;
  postalCode: string;
  distanceKm: number;
  description: string;
  lat: number;
  lng: number;
};

export const zones: Zone[] = [
  {
    name: "Vichy",
    postalCode: "03200",
    distanceKm: 0,
    description:
      "Notre cœur d'activité : bureaux du centre-ville, commerces de la rue de Paris, cabinets médicaux, copropriétés du parc des Sources.",
    lat: 46.1278,
    lng: 3.4267,
  },
  {
    name: "Cusset",
    postalCode: "03300",
    distanceKm: 3,
    description: "Entretien de locaux professionnels, commerces et résidences à Cusset.",
    lat: 46.1346,
    lng: 3.4621,
  },
  {
    name: "Bellerive-sur-Allier",
    postalCode: "03700",
    distanceKm: 3,
    description:
      "Nettoyage de bureaux, copropriétés et commerces à Bellerive et abords de l'Allier.",
    lat: 46.1249,
    lng: 3.4019,
  },
  {
    name: "Abrest",
    postalCode: "03200",
    distanceKm: 5,
    description: "Entretien pour TPE, artisans et particuliers à Abrest.",
    lat: 46.0921,
    lng: 3.4583,
  },
  {
    name: "Creuzier-le-Vieux",
    postalCode: "03300",
    distanceKm: 5,
    description: "Copropriétés et petits commerces sur Creuzier-le-Vieux et Creuzier-le-Neuf.",
    lat: 46.1679,
    lng: 3.4382,
  },
  {
    name: "Saint-Yorre",
    postalCode: "03270",
    distanceKm: 10,
    description: "Sites tertiaires, commerces et résidences à Saint-Yorre.",
    lat: 46.0368,
    lng: 3.4549,
  },
  {
    name: "Hauterive",
    postalCode: "03270",
    distanceKm: 8,
    description: "Entretien régulier pour entreprises et collectivités d'Hauterive.",
    lat: 46.061,
    lng: 3.427,
  },
  {
    name: "Le Vernet",
    postalCode: "03200",
    distanceKm: 4,
    description: "Nettoyage de cabinets, bureaux et copropriétés au Vernet.",
    lat: 46.1091,
    lng: 3.439,
  },
  {
    name: "Charmeil",
    postalCode: "03110",
    distanceKm: 6,
    description: "Interventions proches aéroport Vichy–Charmeil et zones artisanales.",
    lat: 46.1711,
    lng: 3.4045,
  },
  {
    name: "Saint-Germain-des-Fossés",
    postalCode: "03260",
    distanceKm: 14,
    description: "Copropriétés, commerces et bureaux à Saint-Germain-des-Fossés.",
    lat: 46.2074,
    lng: 3.436,
  },
];
